export default __webpack_public_path__ + "static/media/Citroen-Regular.7d6e8698.otf";